import { IActivityConfiguration } from '../interfaces/IActivityComponent';

export interface IActivityRegistry {
    constructors: Function[];
}

export class ActivityMetaModel {
    public static activityConfigurations: IActivityConfiguration[] = [];

    public static registry(annotation: IActivityRegistry): ClassDecorator {
        return <TFunction extends Function>(_target: TFunction) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ActivityMetaModel.activityConfigurations.push(...annotation.constructors.map((cons) => new (cons as any)()));
        };
    }
}

export const extensionNameFileToUpload = 'fileToUpload';
export const extensionNameFilesToUpload = 'filesToUpload';
export const extensionNameScriptToUpload = 'scriptToUpload';
export const extensionNamePathReadOnly = 'pathReadOnly';
export const extensionNameIsInCopySink = 'isInCopySink';
